import React from "react"
import { useIntl } from "gatsby-plugin-intl";

export default function T({children, params}) {
  const intl = useIntl();

  if (process.env.GATSBY_LOG_MISSING_TRANSLATES) {
    let translates = require(`../../intl/${intl.locale}.json`)
    if (!translates[children]) {
      console.warn(`${intl.locale}: ${children} - locale is missing`)
    }
  }

  let translate = intl.formatMessage({id: children});


  if (params && params.length > 0) {
    params.forEach((item, key) => {
      translate = translate.replace(new RegExp(`%${key + 1}`, 'g'), item)
    })
  }

  return <>{translate}</>
}
